import type { QueryClient } from '@tanstack/react-query';
import { setTrackingUser } from '@/features/tracking';
import { useBookingStore } from '@/store/booking-store';
import { useCleanerRegistrationStore } from '@/stores/cleaner-registration-store';
import { userOnboardingCompletionStore } from '@/stores/user-onboarding-completion';
import { useUserAddressStore } from '@/stores/user-address-store';
import { useUserDetailStore } from '@/stores/user-detail-store';
import { useUserStore } from '@/stores/user-store';

/** Wipe client caches and persisted session stores after logout. */
export async function clearSessionState(queryClient: QueryClient) {
  await queryClient.cancelQueries();
  queryClient.clear();

  useUserDetailStore.getState().clearUser();
  useUserAddressStore.getState().clearUser();
  useUserStore.getState().clearUser();
  userOnboardingCompletionStore.getState().resetApplicationCompletion();
  useCleanerRegistrationStore.getState().clearAllData();
  useBookingStore.getState().clearBooking();

  setTrackingUser(null);
}
